module.exports = __webpack_public_path__ + "img/p.856ea306.jpg";